import { InjectionToken, Type } from '@angular/core';
import { DialogComponent } from '@rd/popup/components/dialog/dialog.component';
import { AuthSecureRouteDialogComponent } from '../components/auth-secure-route-dialog/auth-secure-route-dialog.component';
import { AuthSessionExpiredDialogComponent } from '../containers/auth-session-expired-dialog/auth-session-expired-dialog.component';

export const CORE_AUTH_SECURE_ROUTE_DIALOG = new InjectionToken<Type<any>>(
  'CORE_AUTH_SECURE_ROUTE_DIALOG',
  {
    factory: () => AuthSecureRouteDialogComponent,
  },
);

export const CORE_AUTH_SESSION_EXPIRED_DIALOG = new InjectionToken<Type<any>>(
  'CORE_AUTH_SESSION_EXPIRED_DIALOG',
  {
    factory: () => AuthSessionExpiredDialogComponent,
  },
);

export const POPUP_DIALOG = new InjectionToken<Type<any>>('POPUP_DIALOG', {
  factory: () => DialogComponent,
});
